import {
  createBrowserRouter,
  createMemoryRouter,
  type RouteObject,
} from "react-router";

import { withFaroRouterInstrumentation } from "@grafana/faro-react";

type RouteConfig = {
  path: string;
  initialEntry: string;
};

const getBasename = (): string | undefined => {
  const basePath = import.meta.env.VITE_BASE_PATH;

  if (basePath && basePath !== "/") {
    return basePath.replace(/\/$/, "");
  }

  return undefined;
};

export const createPortalRouter = ({
  routeConfig,
  routes,
  skipFaroInstrumentation,
}: {
  routeConfig?: RouteConfig;
  routes: RouteObject[];
  skipFaroInstrumentation?: boolean;
}) => {
  if (routeConfig) {
    const router = createMemoryRouter(routes, {
      initialEntries: [routeConfig.initialEntry],
    });

    return skipFaroInstrumentation
      ? router
      : withFaroRouterInstrumentation(router);
  }

  const router = createBrowserRouter(routes, { basename: getBasename() });

  return skipFaroInstrumentation
    ? router
    : withFaroRouterInstrumentation(router);
};
